import { render, staticRenderFns } from "./MarkdownBlog.vue?vue&type=template&id=0654aa40"
import script from "./MarkdownBlog.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownBlog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports